'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _chemist = require('chemist');

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _style = require('./style.scss');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StoreCreditSummary = (_dec = (0, _chemist.configurable)(), _dec2 = (0, _reactCssModules2.default)(_style2.default, { allowMultiple: true }), _dec(_class = _dec2(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(StoreCreditSummary, _React$Component);

  function StoreCreditSummary() {
    (0, _classCallCheck3.default)(this, StoreCreditSummary);
    return (0, _possibleConstructorReturn3.default)(this, (StoreCreditSummary.__proto__ || (0, _getPrototypeOf2.default)(StoreCreditSummary)).apply(this, arguments));
  }

  (0, _createClass3.default)(StoreCreditSummary, [{
    key: 'isGuestCheckout',
    value: function isGuestCheckout() {
      var user = this.props.user;
      return !(0, _lodash.has)(user, 'firstName') || !(0, _lodash.has)(user, 'totalAvailableStoreCredit');
    }
  }, {
    key: 'hasNoStoreCredits',
    value: function hasNoStoreCredits() {
      var total = this.props.user.totalAvailableStoreCredit;
      return this.toStandardNumericalFormat(total) === '0.00';
    }
  }, {
    key: 'toStandardNumericalFormat',
    value: function toStandardNumericalFormat(total) {
      return total.replace(' ', '').replace(/[^0-9,]/, '').replace(',', '.');
    }
  }, {
    key: 'shouldRenderInsideBox',
    value: function shouldRenderInsideBox() {
      return !this.props.simple;
    }
  }, {
    key: 'componentStyles',
    value: function componentStyles() {
      var s = [];
      if (this.shouldRenderInsideBox()) s.push('storeCreditSummary--box');
      s.push('storeCreditSummary');

      return {
        styleName: s.join(' ')
      };
    }
  }, {
    key: 'renderNoStoreCredits',
    value: function renderNoStoreCredits() {
      return _react2.default.createElement(
        'div',
        { styleName: 'continueShopping' },
        this.props.children
      );
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.isGuestCheckout() || this.hasNoStoreCredits()) return this.renderNoStoreCredits();

      return _react2.default.createElement(
        'ul',
        this.componentStyles(),
        _react2.default.createElement(
          'li',
          null,
          _react2.default.createElement(
            'h3',
            null,
            'Hello ',
            this.props.user.firstName
          ),
          _react2.default.createElement(
            'p',
            null,
            'You have ',
            _react2.default.createElement(
              'span',
              { styleName: 'storeCreditSummary--currency' },
              this.props.user.totalAvailableStoreCredit
            ),
            ' of available store credit that will be applied to your purchase.'
          )
        ),
        _react2.default.createElement(
          'li',
          null,
          this.props.children
        )
      );
    }
  }]);
  return StoreCreditSummary;
}(_react2.default.Component), _class2.propTypes = {
  user: _react.PropTypes.object,
  simple: _react.PropTypes.bool
}, _temp)) || _class) || _class);
exports.default = StoreCreditSummary;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/StoreCreditSummary/index.js
// module id = 339
// module chunks = 0